<template xmlns:v-pikaday="http://www.w3.org/1999/xhtml">
  <form class="" v-if="value">
    <div class="">
      <label for="ecard-message" class="">ข้อความเชิญชวน</label>
      <text-counter class="fs-xs fl-right" :text="value.message" :limit="messageMaxLength" />
      <textarea class="form__textarea" id="ecard-message" v-model="value.message"></textarea>
      <div class="alert alert--error" v-show="validator.$errors['value.message'].empty">กรุณากรอกข้อความอวยพร</div>
      <div class="alert alert--error" v-show="validator.$errors['value.message'].maxLength">ข้อความต้องยาวไม่เกิน {{ messageMaxLength | comma }} ตัวอักษร</div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <label for="ecard-type" class="form__label">เนื่องในวัน</label>

        <div class="form__select">
          <select id="ecard-type" v-model="value.type" @change="onTypeChange">
            <option :value="$const.SPECIAL_EVENT_TYPES.BIRTHDAY">วันเกิด</option>
            <option :value="$const.SPECIAL_EVENT_TYPES.ANNIVERSARY">วันครบรอบ</option>
            <option :value="$const.SPECIAL_EVENT_TYPES.OTHER">อื่น ๆ</option>
          </select>
        </div>
        <input type="text" class="form-control form__text" name="custom_type" id="ecard-custom" ref="customType"
               placeholder="วันขึ้นบ้านใหม่"
               v-model="value.custom_type"
               v-show="value.type === $const.SPECIAL_EVENT_TYPES.OTHER" />
        <div class="alert alert--error" v-show="validator.$errors['value.custom_type'].empty">กรุณากรอกโอกาสพิเศษ</div>
      </div>

      <div class="col-sm-4">
        <label for="ecard-name" class="form__label">ของ</label>
        <input type="text" class="form-control form__text" name="title" id="ecard-name" v-model="value.name" required />
        <div class="alert alert--error" v-show="validator.$errors['value.name'].empty">กรุณากรอกชื่อ</div>
      </div>

      <div class="col-sm-4">
        <label for="ecard-date" class="form__label">ในวันที่</label>
        <div class="row">
          <div class="col-xs-4 col-sm-4 pr-0">
            <div class="form__select">
              <select id="ecard-date" v-model="value.day" required>
                <option value="">- วัน -</option>
                <option v-for="item in dayList" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-8 col-sm-8">
            <div class="form__select">
              <select id="ecard-month" v-model="value.month" required>
                <option value="">- เดือน -</option>
                <option v-for="item in monthList" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-sm-4">
        <div class="">
          <label for="ecard-target" class="form__label">เป้าหมาย</label>
          <input type="number" class="form-control form__text" placeholder="กรุณากรอกจำนวนเงิน" id="ecard-target" autocomplete="off" @keydown="targetKeyDown" @keyup="targetKeyUp" @focus="targetFocus" @blur="targetUnfocus" required v-model="value.target" />
          <div class="alert alert--error" v-show="validator.$errors['value.target'].empty">กรุณากรอกเป้าหมาย</div>
          <div class="alert alert--error" v-show="validator.$errors['value.target'].minimum">จำนวนเงินขั้นต่ำ {{ targetMinimum | comma }} บาท</div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="">
          <label for="ecard-deadline" class="form__label">กำหนดวันสิ้นสุดการระดมเงิน</label>
          <div class="wrapper-pickdate">
          <span class="ic-calendar"></span><input class="form-control form__text -pickdate" placeholder="31/01/2018" type="text"  id="ecard-deadline" readonly v-pikaday:selected="setEndDate" v-model="value.end_date" />
        </div>
        </div>
      </div>
    </div>

    <div class="mt-30" v-if="showEcardForm">
      <div class="">
        <input type="checkbox" name="" id="ecard-check" class="-lg" v-model="value.send_ecard">
        <label for="ecard-check" class="">ส่งเป็น e-card เพื่อให้ครอบครัวหรือเพื่อนของคุณได้รู้ถึงเรื่องราวดีๆ</label>
      </div>
    </div>

    <div v-if="value.send_ecard && showEcardForm">
      <send-email-form v-model="value.send_ecard_emails" ref="emailForm" />
      <div class="text-remark lh1-2">*ระบบจะส่ง e-card ของคุณทันทีที่การบริจาคของคุณสำเร็จ</div>
    </div>

    <div class="_clearfix mt-30">
      <div class="">
        <button type="button" class="ma-auto btn btn--default" @click.prevent="submit">{{ submitButtonText }}</button>
      </div>
    </div>
  </form>
</template>

<script>
  import SendEmailForm from '@/components/SendEmailForm'
  import TextCounter from '@/components/TextCounter'

  export default {
    name: 'SpecialEventForm',

    components: {
      SendEmailForm,
      TextCounter
    },

    props: {
      value: {
        type: Object,
        default: null
      },

      submitButtonText: {
        type: String,
        default: 'ต่อไป >>'
      },

      showEcardForm: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      monthList () {
        return this.$const.MONTH_LIST.map(item => {
          return {
            label: item.name,
            value: item.value
          }
        })
      },

      dayList () {
        let numDays = 31
        const item = this.$const.MONTH_LIST.find(item => item.value === this.value.month)
        if (item) {
          numDays = item.days
        }
        const items = []
        for (let day = 1; day <= numDays; day++) {
          items.push({
            label: day,
            value: day.toString().padStart(2, '0')
          })
        }
        return items
      }
    },

    created () {
      this.initValidator()
    },

    data () {
      return {
        validator: null,
        messageMaxLength: 250,
        targetMinimum: 1000,
        submitting: false
      }
    },

    methods: {
      initValidator () {
        this.validator = this.$validator.init(this, {
          'value.message': { checkEmpty: true, maxLength: this.messageMaxLength },
          'value.name': { checkEmpty: true },
          // 'value.day': { checkEmpty: true },
          // 'value.month': { checkEmpty: true },
          'value.target': { checkEmtpy: true, minimum: this.targetMinimum },
          'value.custom_type': { checkEmpty: true, dependOn: { field: 'value.type', value: this.$const.SPECIAL_EVENT_TYPES.OTHER } }
        })
      },

      emit () {
        return this.$emit('input', this.value)
      },

      getEventName () {
        switch (this.value.type) {
          case this.$const.SPECIAL_EVENT_TYPES.BIRTHDAY:
            return `วันเกิด`
          case this.$const.SPECIAL_EVENT_TYPES.ANNIVERSARY:
            return `วันครบรอบ`
        }
        return this.value.custom_type
      },

      submit () {
        if (this.value.send_ecard && this.showEcardForm && !this.$refs.emailForm.validate()) {
          return
        }

        if (!this.validator.validate()) {
          this.$forceUpdate()
          return
        }

        const eventName = this.getEventName()
        this.value.title = `${this.value.name} เนื่องใน${eventName}`

        this.emit()
        this.$emit('submit', this.value)
      },

      setEndDate (date) {
        this.value.end_date = date
        this.emit()
      },

      targetFocus () {
        if (!this.value.target) {
          this.value.target = ''
          this.emit()
        }
      },

      targetKeyDown (e) {
        if (!this.value.target && e.keyCode === 48) {
          e.preventDefault()
        }
      },

      targetKeyUp () {
        if (this.value.target) {
          this.value.target = parseInt(this.value.target)
          if (isNaN(this.value.target)) {
            this.value.target = 0
            this.emit()
          }
        }
      },

      targetUnfocus () {
        if (isNaN(this.value.target)) {
          this.value.target = 0
          this.emit()
        }
      },

      onTypeChange () {
        if (this.value.type === this.$const.SPECIAL_EVENT_TYPES.OTHER) {
          this.$nextTick(() => {
            this.$refs.customType.focus()
          })
        }
      }
    },

    watch: {
      'value.month': function () {
        if (!this.value.month) {
          this.value.day = ''
        } else if (!this.dayList.find(item => item.value === this.value.day)) {
          this.value.day = '01'
        }
        this.emit()
      }
    }
  }
</script>

<style lang="scss" scoped>
.form__email {
  margin-bottom: 0;
}
.wrapper-pickdate {
  position: relative;
  .ic-calendar {
      content: "";
      position: absolute;
      top: 22px;
      right: 20px;
      width: 22px;
      height: 22px;
      background: url("../../../../assets/img/ic-calendar@2x.png") no-repeat center center;
      background-size: 100%;
      opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// form.vue?dbe5217e